import * as React from 'react';
import { AppState } from '../store'
import { AppActions } from '../containers/ItemContainer'

interface OwnProps {}

type AppProps = OwnProps & AppState & AppActions;

export const ItemComponent: React.SFC<AppProps> = (props: AppProps) => {
  return (
    <div className="menu">
      引用元: <a href="http://www.mcdonalds.co.jp/quality/allergy_Nutrition/nutrient2.php?id=1">マクドナルド 栄養成分一覧表</a>
      <ul>
        {props.items.map(i => (<li>
          <input type="checkbox" checked={i.selecetd} onChange={(e) => props.toggleSelected(i.id)} />
          {i.name}</li>))}
      </ul>
    </div>
  );
};
// export default class extends React.Component<AppProps, AppState> {
//   private toggleSelected(id: number) {
//     this.props.
//   }

//   public render() {
//     return (
//       <ul>
//         {this.state.items.map(i => (<li>
//           <input type="checkbox" checked={i.selecetd} onChange={(e) => props.toggleSelected(i.id)} />
//           {i.name}</li>))}
//       </ul>
//     );
//   }
// }